# jQuery
window.$ = window.jQuery = require('jquery/dist/jquery')

# Bootstrap
require('bootstrap/dist/js/bootstrap')
require('bootstrap/js/affix')
require('bootstrap-colorpicker/dist/js/bootstrap-colorpicker')

# Plugin JS
require('lodash/index')
window.moment = require('moment')
require('moment-timezone/builds/moment-timezone-with-data')
window.UaParser = require('ua-parser-js')
window.Decimal = require('decimal.js');

# D3
require('d3/d3')
#require('clipboard/dist/clipboard.js')
window.Highcharts = require('highcharts/highcharts')
require('highcharts/modules/funnel')(window.Highcharts)

window.h337 = require('heatmap.js/build/heatmap.js')
#require('zc_statistics')

# Gridster
require('gridster/dist/jquery.gridster.min.js')

# TODO: These do not work with webpack
#require('pickadate/lib/picker')
#require('pickadate/lib/picker.date')
#require('pickadate/lib/picker.time')

#= AngularJS
require('angular/angular')
require('angular-translate/dist/angular-translate')
require('angular-translate-loader-static-files/angular-translate-loader-static-files')
require('angular-animate/angular-animate')
require('angular-messages/angular-messages')
require('angular-resource/angular-resource')
require('angular-cookies/angular-cookies')
require('angular-local-storage/dist/angular-local-storage')
require('angular-ui-router/release/angular-ui-router')
require('angular-sanitize/angular-sanitize')
require('angular-bootstrap/ui-bootstrap')
require('angular-bootstrap/ui-bootstrap-tpls')
require('ng-csv/build/ng-csv')
require('angular-xeditable/dist/js/xeditable.js')
require('ngclipboard/dist/ngclipboard.js')
require('angular-bootstrap-datetimepicker/src/js/datetimepicker')
require('angular-bootstrap-datetimepicker/src/js/datetimepicker.templates')
require('angular-md5/angular-md5')
require('highcharts-ng/dist/highcharts-ng')
require('angularjs-slider/dist/rzslider')

require('select2/dist/js/select2.full.min.js')
require('select2/dist/css/select2.min.css')

window.Flow = require('ng-flow/dist/ng-flow-standalone')

# Angular colorpicker
require('angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.js')

# Markdown
require('marked/marked.min.js')
require('angular-marked/lib/angular-marked.js')

#require('angular-loading-bar/build/loading-bar.js')
require('highlight.js/lib/index.js')
require('angular-highlightjs/angular-highlightjs.js')

window.sift = require('sift/sift')

require('gridster/dist/jquery.gridster.min.css')
require('bootstrap/dist/css/bootstrap.css')
#require('angular-loading-bar/build/loading-bar.css')
require('alertify/themes/alertify.core.css')
require('alertify/themes/alertify.default.css')
require('pickadate/lib/compressed/themes/classic.css')
require('pickadate/lib/compressed/themes/classic.date.css')
require('pickadate/lib/compressed/themes/classic.time.css')
require('font-awesome/css/font-awesome.css')
require('angular-bootstrap-colorpicker/css/colorpicker.min.css')
require('angular-bootstrap-datetimepicker/src/css/datetimepicker.css')
require('highlight.js/styles/railscasts.css')
require('angular-xeditable/dist/css/xeditable.min.css')
require('angularjs-slider/dist/rzslider.css')

window.gql = require('graphql-tag');



// WEBPACK FOOTER //
// ./src/external.coffee